module.exports = __webpack_public_path__ + "static/media/upload.07708d3d.svg";